import React, { Component } from "react";
import CreateAdmin from "./CreateAdmin";
import { CreateAdminActions } from "../../../../store/CreateAdmin";
import { connect } from "react-redux";
import withAppShell from "../../../hoc/withAppShell/WithAppShell";
import { SchoolInformationActions, UserProfileActions } from "../../../../store";
import lodashUtil from 'lodash'
import { getKeyFromLS } from '../../../../utils/LocalStorageUtil'
class CreateAdminContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  componentWillMount() {
    let i18n;
    if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
      i18n = getKeyFromLS("i18n");
    } else {
      i18n = this.props.i18n
    }
    this.setState({
      i18n: i18n
    })
  }

  showContextualHelp = (props, event) => {
    let content = props.contextualHelp["manageAdmins"];
    if (content !== undefined) {
        props.toggleDrawer("right", true, content)(event)
    }
}
  render() {
    return <CreateAdmin {...this.props} {...this.state} showContextualHelp={this.showContextualHelp}/>;
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    createAdminInServer: (ownerId, schoolId, data) => dispatch(CreateAdminActions.createAdminInServer(ownerId, schoolId, data)),
    fetchExistingAdmins: (schoolId) => dispatch(CreateAdminActions.fetchExistingAdmins(schoolId)),
    editSchoolInformation: (ownerId, schoolId, data) => dispatch(SchoolInformationActions.editSchoolInformation(ownerId, schoolId, data)),
    updateUserProfile: (userData) => dispatch(UserProfileActions.updateUserProfile(userData)),
    sendEmail: (emailId, transferOwnerId, schoolId) => dispatch(UserProfileActions.sendEmail(emailId, transferOwnerId, schoolId)),
    deleteAdminProfile: (userData) => dispatch(CreateAdminActions.deleteAdminProfile(userData))
  };
};

const mapStateToProps = state => {
  return {
    user: state.createAdmin.user,
    activeSchool: state.schoolInformation.activeSchool,
    userInformation: state.userProfile.userInformation,
    adminCreationError: state.createAdmin.adminCreationError,
    existingAdmins: state.createAdmin.existingAdmins,
    createAdminInProgress: state.createAdmin.createAdminInProgress,
    createAdminFailed: state.createAdmin.createAdminFailed,
    updateSchoolinformationInProgress: state.schoolInformation.updateSchoolinformationInProgress,
    i18n: state.i18nMessages.i18n
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAppShell(CreateAdminContainer));
